import { render, staticRenderFns } from "./MessageResetPassword.html?vue&type=template&id=30f93037&scoped=true&external"
import script from "./MessageResetPassword.js?vue&type=script&lang=js&external"
export * from "./MessageResetPassword.js?vue&type=script&lang=js&external"
import style0 from "./MessageResetPassword.scss?vue&type=style&index=0&id=30f93037&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f93037",
  null
  
)

export default component.exports